<template>
  <button
    @click="refreshBots"
    :disabled="isRefreshed"
    class="border-2 border-gray-250 w-10 h-10 rounded-xl flex items-center justify-center group transition-300 hover:bg-gray-250 disabled:cursor-not-allowed disabled:bg-gray-250"
  >
    <template v-if="isRefreshed">
      <div class="spinner-loading-animation" />
    </template>
    <template v-else>
      <span
        class="icon-refresh !text-lg text-gray-450 transition-300 group-hover:text-dark"
      />
    </template>
  </button>
</template>

<script setup lang="ts">
interface Props {
  isRefreshed: boolean;
}
defineProps<Props>();
const emit = defineEmits<{
  (e: "refreshBots"): void;
}>();

const refreshBots = () => {
  emit("refreshBots");
};
</script>

<style scoped>
.spinner-loading-animation {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background:
    radial-gradient(farthest-side, #6f767e 94%, #0000) top/3.8px 3.8px no-repeat,
    conic-gradient(#0000 30%, #6f767e);
  -webkit-mask: radial-gradient(
    farthest-side,
    #0000 calc(100% - 3.8px),
    #000 0
  );
  animation: spinner-loading 1s infinite linear;
}

@keyframes spinner-loading {
  100% {
    transform: rotate(1turn);
  }
}
</style>
